// extracted by mini-css-extract-plugin
module.exports = {"contTituloPage":"styles_contTituloPage__23oaC","h1":"styles_h1__3kluJ","subTitle":"styles_subTitle__1OwvN"};